import { render, staticRenderFns } from "./AgreementsFilesList.vue?vue&type=template&id=b9be4562&scoped=true&"
import script from "./AgreementsFilesList.vue?vue&type=script&lang=js&"
export * from "./AgreementsFilesList.vue?vue&type=script&lang=js&"
import style0 from "./AgreementsFilesList.vue?vue&type=style&index=0&id=b9be4562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9be4562",
  null
  
)

export default component.exports